import Route from '@ember/routing/route';

export default class AuthenticatedPlaylistsShowIndexRoute extends Route {}
